/*
import {
  ht,
  cr,
  a,
  BoxC,
  HtyC,
  IptC,
  LblC,
  MsgC,
  SrlC,
  GridC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import * as HtyC from "./_ccmHtyC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';

import * as icvi11b from './icvI11___Ci'; 

export const N = (pz: {
  sPz: ht.dz,
}) => {

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnStfz',
          boxStlz: a(`mb/2`),
          lineCs: [{
            cellCs: [
              {
                oClds: [
                ]
              },
              {
                oClds: [
                ]
              },
              {
                oClds: [
/*
                  cr.c(LblC.N, {
                    key: -10,
                    abtType: 'ftnCmnz',
                    boxStlz: a('dw/23'),
                    lblCz: {
                      boxStlz: a('dw/8'),
                      textz: {
                        pfx: '変更履歴',
                      }
                    },
                    cttCz: {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          abtType: 'ftnCmnz',
                          cz: {
                            bEdit: true,
                            iptType: 'pcr',
                            ls: [],
                          },
                        })
                      ]
                    },
                  })
*/
                  cr.c(HtyC.N, {
                    key: -10,
                    sPz: pz.sPz,
                    cz: {
                      elm: 'i11r',
                    }
                  })

                ]
              }
            ]
          }]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

/*
            cr.c(MsgC.N, {
              key: -10,
              abtType: 'cttCmnz',
              boxStlz: a('mb/2'),
              cz: {
                ls: [
                  {
                    mkrCz: {
                      textz: {
                        pfx: _lblz.msgz.cttz.mkr
                      }
                    },
                    msgCz: {
                      textz: {
                        pfx: _lblz.msgz.cttz.msg
                      }
                    }
                  },
                ]
              },
            }),
*/

            cr.c(SrlC.V, {
              key: -20,
              abtType: 'cttCmnz',
              oClds: [
                cr.c(icvi11b.D, {
                  key: -10,
                  sPz: pz.sPz,
                })
              ],
            }),

            cr.c(icvi11b.B, {
              key: -30,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'gn7',
              },
            }),

          ]
        })

      ]
    })
  );
};
